import DataMapping from "./data-mapping";

export default DataMapping;